import { $ } from 'src/shared/js/utils/dom';
import AniScroll from 'src/shared/js/modules/ani-scroll';

const toTopWrapper = $('.scroll-top');

if (toTopWrapper) {
  const toTopButton = $('.scroll-top > button');
  const header = $('.header');
  const logo = $('.header__logo', header);

  function handleScroll() {
    const headerHeight = header.offsetHeight;

    if (window.scrollY >= headerHeight) {
      if (!toTopWrapper.classList.contains('is-active'))
        toTopWrapper.classList.add('is-active');
    } else {
      if (toTopWrapper.classList.contains('is-active'))
        toTopWrapper.classList.remove('is-active');
    }
  }

  function scrollToTop() {
    AniScroll(0, 500, 'easeOutQuad', () => {
      if (logo) {
        logo && logo.focus();
      }
    });
  }

  toTopButton.addEventListener('click', scrollToTop);
  document.addEventListener('scroll', handleScroll);
}
